import React, { FC, useMemo, useState } from "react";
import { tombac, Text, Button, Box, useToasts, useTombac } from "tombac";
import { CopyIcon } from "tombac-icons";
import { UserProductSafe } from "./../legolandApi/legolandApiTypes";
import { renderProductIcon } from "../../icons";

export type ProductsApiKeysProps = {
  products: Record<string, UserProductSafe[]>;
};

export const ProductsApiKeys: FC<ProductsApiKeysProps> = ({ products }) => {
  return Object.entries(products).map((product) => {
    const [key, products] = product;
    const productsElement = products.map((p) => (
      <span> {renderProductIcon(p.id)}</span>
    ));

    return (
      <Box
        $paddingBottom="2sp"
        $marginBottom="2sp"
        $borderBottom={`1px solid ${tombac.color("neutral", 300)}`}
      >
        <Box>{productsElement}</Box>
        <ApiKeyField apiKey={key} />
      </Box>
    );
  });
};

function ApiKeyField({ apiKey }: { apiKey: string }) {
  const { addToast } = useToasts();
  const [isMasked, setIsMasked] = useState(true);

  const apiKeyMasked = isMasked
    ? apiKey.slice(-4).padStart(apiKey.length - 4, "⦁")
    : apiKey;

  const clientApiKey = (
    <>
      <Text $pt="0.5sp" $display="inline-block">
        {apiKeyMasked}
      </Text>
    </>
  );

  const handleCopyClick = async (apiKey: string) => {
    try {
      await navigator.clipboard.writeText(apiKey);
      addToast("The API key is copied to the clipboard", "success");
    } catch (e) {
      addToast("Failed to copy the API key to the clipboard", "danger");
    }
  };

  return (
    <Box
      $alignItems="center"
      $display="flex"
      $gap="1sp"
      className="Product__api-key"
      onMouseLeave={() => setIsMasked(true)}
    >
      <Text $mt="0.2em" as="div" onMouseEnter={() => setIsMasked(false)}>
        {clientApiKey}
      </Text>
      <Button
        onClick={() => handleCopyClick(apiKey)}
        shape="circle"
        size="xs"
        variant="flat"
      >
        <CopyIcon />
      </Button>
    </Box>
  );
}
